import { Icon } from "@portal/lib/icons/icons";
import { Flex } from "../Flex/Flex";
import { TypographyText } from "../Typography/AntTypography";

interface PopConfirmContentProps {
  title: string;
  desc: string;
  titleStyles?: React.CSSProperties;
  descStyles?: React.CSSProperties;
  iconColor?: React.CSSProperties["color"];
  icon?: React.ReactNode;
}

function PopConfirmContent(props: PopConfirmContentProps) {
  const { title, desc, titleStyles, descStyles, icon, iconColor } = props;
  const WarningIcon = icon ? (
    icon
  ) : (
    <Icon
      icon={["far", "exclamation-circle"]}
      color={iconColor ?? " var(--gold-6)"}
    />
  );
  const Title = (
    <TypographyText fs={"14"} style={titleStyles} strong>
      {title}
    </TypographyText>
  );
  const Desc = (
    <TypographyText fs={"14"} style={descStyles}>
      {desc}
    </TypographyText>
  );
  return (
    <Flex vertical space={"8"}>
      <Flex align="center" space={"4"}>
        {WarningIcon}
        {Title}
      </Flex>
      {Desc}
    </Flex>
  );
}

export { PopConfirmContent };
